import React from 'react';
import PropTypes from 'prop-types';
import { WDHImageSpot } from '../../../demant-feature/wdh-image-spot';
import { ImageSpotElementAsBackground } from './image-as-background';
import { SiteCoreLink } from '../../project/sitecore-content-parser';
import Circle from '../../project/circle';
var CircleImageSpot = function CircleImageSpot(props) {
  var renderHeader = function renderHeader(index) {
    var header = props.elements[index].querySelector('.image-spot-element-header');
    return /*#__PURE__*/React.createElement(React.Fragment, null, header && header.innerHTML !== '' && /*#__PURE__*/React.createElement("div", {
      className: "image-spot-element-header"
    }, /*#__PURE__*/React.createElement(Circle, null), /*#__PURE__*/React.createElement("div", {
      className: "image-spot-element-header-inner",
      dangerouslySetInnerHTML: {
        __html: header.innerHTML
      }
    })));
  };
  var renderLink = function renderLink(index) {
    var link = props.elements[index].querySelector('.image-spot-element-link a');
    return /*#__PURE__*/React.createElement(React.Fragment, null, link && /*#__PURE__*/React.createElement("div", {
      className: "image-spot-element-link"
    }, /*#__PURE__*/React.createElement(SiteCoreLink, {
      htmlAnchorElement: link
    })));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.elements.map(function (element, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "image-spot-element",
      key: "image-element-".concat(index)
    }, renderHeader(index), renderLink(index));
  }));
};
CircleImageSpot.propTypes = {
  elements: PropTypes.arrayOf(PropTypes.instanceOf(HTMLLIElement)).isRequired
};
var imageSpot = new WDHImageSpot('.image-spot:not(.live-circles)');
imageSpot.wrapImageWithLink = true;
imageSpot.linkClasses = ['like-button-small'];
imageSpot.run();
var imageSpotElementAsBackground = new ImageSpotElementAsBackground();
imageSpotElementAsBackground.wrapImageWithLink = true;
imageSpotElementAsBackground.linkClasses = ['like-button-small'];
imageSpotElementAsBackground.run();
var animatedImageSpot = new WDHImageSpot('.image-spot.element-as-background.live-circles');
animatedImageSpot.reactApp = CircleImageSpot;
animatedImageSpot.run();